// extracted by mini-css-extract-plugin
export default {"dotSpinner":"useBackdrop_dotSpinner__gui2V","dotSpinner__dot":"useBackdrop_dotSpinner__dot__3t2iS","pulse0112":"useBackdrop_pulse0112__nFSnF"};